






















































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl,
  IsMore
} from "@root/lib/decorator";
import { moneyRegexp } from "@root/lib/regexps";
import NP from "number-precision";
import debounce from "lodash.debounce";
import tabTable from "./components/tabTable.vue";

const common = namespace("common");
const root = namespace("root");
const bonus = namespace("bonus");

@Component({
  components: { tabTable },
  filters: {
    formatMoney(money = 0) {
      // return money.replace(/\d(?=(\d{3})+.)/g, "$&,");
      if (!money) return "0.00";
      return money.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
})
@pagination("getData", {
  pageSize: 50
})
@SearchbarControl()
@loading()
@IsMore(true)
export default class wallet extends Vue {
  @common.Action queryDataDictionaryListLang;
  @root.State ddCodes;

  @bonus.State REWAED_TYPE_OPTIONS;
  @bonus.Action queryMyBusinessList; // 待入账
  @bonus.Action getMyBonusAccount;
  @bonus.Action withdraw;
  @bonus.Action exportK1BonusFlow;
  @bonus.Action queryMyOuterDtList; // 已入账

  @bonus.Action exportScanBonusBusiness;
  @bonus.Action exportCreditedRewardFlow;
  @bonus.Action exportWithdrawRewardFlow;
  @bonus.Action exportPaymentOrderRewardFlow;
  @bonus.Action exportCouponBonusBusiness;
  @bonus.Action newWithdraw;
  @bonus.Action getMyPendingBonus;

  private dataList = [];
  private dicOptions = [];

  private tabLoading = false;
  private loading = false;
  private isWithdrawLoading = false;
  private isShowExportDialog = false;
  private exportParams = "";

  private headerForm = {
    dateTime: [],
    bountyMoneyNum: null,
    status: "02"
  };

  private pageHeaderData = {
    balance: 0,
    bountry: 0,
    checkBountry: 0,
    freeze: 0
  };

  get dataListComputed() {
    return this.dataList;
  }
  get tableStatus() {
    return Number(this.headerForm.status);
  }
  get userInfo() {
    // 注意： k-one在这里请求时的userCode是本地的orgCode
    return JSON.parse(localStorage.getItem("userInfo") || null);
  }
  get userCode() {
    return (this.userInfo && this.userInfo.orgCode) || "";
  }
  get randomId() {
    return Date.now();
  }

  hasfilterStatus(arr) {
    return (arr || []).includes(this.tableStatus);
  }
  // isOaCooperation: any = '';
  async created() {
    this.getDefaultDate();
    // this.isOaCooperation = localStorage.getItem("isOaCooperation");
    await this.getData();
    await this.$dd
      .register(["BONUS_SOURCE", "WT_REWARD_MG_TYPE", "ORDER_STATUS"])
      .query();
  }

  onBounty = debounce(() => {
    this.goOnBounty();
  }, 500);
  async goOnBounty() {
    await (this.$refs.headerForm as any).validate(async valid => {
      if (valid) {
        let userCode = this.userCode || "";
        try {
          this.isWithdrawLoading = true;
          const { bountyMoneyNum } = this.headerForm;
          // const input = {
          //   list: [],
          //   accountType: "103", // 103 奖励金
          //   userCode, // userinfo
          //   productType: "WITHDRAW_01", // -01申请
          //   direction: "2",
          //   amount: bountyMoneyNum,
          //   memo: "K1奖励金对象",
          //   businessTag: "K1"
          // };
          // const {
          //   data: {
          //     withdraw: { success }
          //   }
          // } = await this.withdraw({ input });
          await this.newWithdraw({
            amount: bountyMoneyNum
          });
          // if (success) {
          await this.getData();
          this.headerForm.bountyMoneyNum = "";
          (this.$refs.headerForm as any).resetFields();
          this.$message.success("提交成功！");
          // } else {
          //   this.$message.error("提交失败");
          // }
        } catch (error) {
          console.error(error);
          this.$message.error(error || "提交失败");
        } finally {
          this.isWithdrawLoading = false;
        }
      } else {
        console.log("error submit!!");
        return false;
      }
    });
  }

  @loadingCatch
  async getData() {
    const { pageSize, currentPage: pageNum } = this as any;
    const pageInput = {
      pageSize,
      pageNum
    };
    try {
      const { status, bountyMoneyNum, dateTime } = this.headerForm;

      let input: any = {};
      const [startTime = "", endTime = ""] = dateTime || [];
      input = {
        startTime,
        endTime
      };

      this.getMyBonusAccountApi();
      this.getMyPendingBonusFn();
      if (status) {
        if (status === "02") {
          Object.assign(input, {
            fundType: "02",
            userCode: this.userCode,
            productTypeList: ["ADJUSTMENT", "PAYMENT"]
          });
          (this as any).loading = true;
          let { total, list } = await this.queryMyOuterDtList({
            input,
            pageInput
          });
          (this as any).total = total;
          this.dataList = list;
          (this as any).loading = false;
          return;
        }
        if (status === "03") {
          input["productType"] = "WITHDRAW";
        }
        if (status === "01") {
          input["productType"] = "ADJUSTMENT";
          input["businessStatus"] = status;
        }
        // 冻结中
        if (status === "04") {
          input["productType"] = "PAYMENT";
          input["businessStatus"] = "01";
        }
        if (status === "05") {
          input["productType"] = "ADJUSTMENT";
          input["businessStatus"] = "01";
          input.fundTypes = [23, 42];
        }
      }
      (this as any).loading = true;
      let { total, list } = await this.queryMyBusinessList({
        accountBusiness: input,
        pageInput
      });
      (this as any).total = total;
      this.dataList = list;
      (this as any).loading = false;
    } catch (err) {
      (this as any).loading = false;
      this.dataList = [];
      console.error(err);
      (this as any).total = 0;
    }
  }

  async getMyBonusAccountApi() {
    try {
      const {
        list: { accountOuterSubsetList = [], accountAmount }
      } = await this.getMyBonusAccount();
      const typeLabel = status => {
        const obj = accountOuterSubsetList.find(
          item => parseInt(item && item.fundType) == status
        );
        return (obj && obj.accountAmount) || 0;
      };
      // 可使用金额
      const canUseMoneyStr = typeLabel(2);
      // 待审核金额
      const lockMoneyStr = typeLabel(3);
      // 奖励金余额
      // const totalMoneyStr = accountAmount;
      // 冻结金额
      const freezeMoneyStr = typeLabel(4);
      const totalMoneyStr = NP.plus(
        canUseMoneyStr,
        lockMoneyStr,
        freezeMoneyStr
      ).toFixed(2);
      this.pageHeaderData = {
        balance: totalMoneyStr as any,
        bountry: canUseMoneyStr,
        checkBountry: lockMoneyStr,
        freeze: freezeMoneyStr
      };
    } catch (error) {
      console.log(error);
    }
  }

  pendingK1ScanBonus: any = ""; //待入账-k1扫码
  pendingCouponDeductBonus: any = ""; //待入账-优惠券抵扣
  async getMyPendingBonusFn() {
    let res: any = await this.getMyPendingBonus();
    console.log(res, "---getMyPendingBonus");
    let { data = {} } = res;
    this.pendingK1ScanBonus = data.pendingK1ScanBonus || "";
    this.pendingCouponDeductBonus = data.pendingCouponDeductBonus || "";
  }
  /**
   * 
    01：待入账-扫码
    02：已入账 39
    03：提现记录 40
    04：待入账-订单 41
   */
  async exportExcelFn() {
    const { dateTime, status } = this.headerForm;
    const {
      exportScanBonusBusiness, // 待入账-扫码
      exportCreditedRewardFlow, // 已入账
      exportWithdrawRewardFlow, // 提现导出
      exportPaymentOrderRewardFlow, // 待入账-订单
      exportCouponBonusBusiness //待入账-优惠券抵用
    } = this;
    let input = {};
    const [startTime = "", endTime = ""] = dateTime;
    input = {
      startTime,
      endTime
    };
    const params: any = {
      input
    };
    // 待入账-扫码
    if (status === "01") {
      this.exportParams = "42";
      console.log("待入账-扫码");
      return exportScanBonusBusiness(params);
    }
    // 02：已入账
    if (status === "02") {
      this.exportParams = "39";
      return exportCreditedRewardFlow(params);
    }
    // 03：提现记录
    if (status === "03") {
      this.exportParams = "40";
      return exportWithdrawRewardFlow(params);
    }
    // 04：待入账-订单
    if (status === "04") {
      this.exportParams = "41";
      return exportPaymentOrderRewardFlow(params);
    }
    // 04：待入账-订单
    if (status === "05") {
      params.input.fundTypes = [23, 42];
      this.exportParams = "68";
      return exportCouponBonusBusiness(params);
    }
  }

  handleExport() {
    (this.$refs.gtExportDialog as any).visible = true;
  }
  async warnOp(msg) {
    await this.$confirm(msg, "", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    });
  }

  handleResetBtnClick() {
    this.headerForm.dateTime = [];
    this.getData();
  }

  tabToggleHandle(status) {
    this.$set(this.headerForm, "status", status);
    // this.handleResetBtnClick();
    this.headerForm.dateTime = [];
    this.getDefaultDate();
    (this as any).onSearchBtnClick();
  }
  validIntNum = (rule, value, callback) => {
    const isValid = moneyRegexp.test(String(value)) && parseInt(value);
    if (isValid) {
      const currentMoney = this.getObjVal("bountry");
      console.log(value, "value");
      if (Number(currentMoney) < Number(value)) {
        callback(new Error("可提现奖励金不足"));
      } else {
        callback();
      }
    } else {
      if (Number(value) === 0) {
        callback(new Error("提现奖励金不可为0"));
      } else {
        callback(new Error("格式错误"));
      }
    }
  };
  getObjVal(prop) {
    return (this.pageHeaderData && this.pageHeaderData[prop]) || 0;
  }
 // 格式化时间
 formatDate(datetime) {
    const time = new Date(datetime);
    const year = time.getFullYear();
    const month = (time.getMonth() + 1).toString().padStart(2, "0");
    const date = time
      .getDate()
      .toString()
      .padStart(2, "0");
    return year + "-" + month + "-" + date ;
  }
  getDefaultDate() {
    const start = new Date();
    this.$set(
      this.headerForm.dateTime,
      0,
      this.formatDate(start.getTime() - 1000 * 3600 * 24 * 30)+ " 00:00:00"
    );
    this.$set(this.headerForm.dateTime, 1, this.formatDate(start.getTime())+ " 23:59:59");
  }

}
